import { DEVICE_BATCHES_PATH } from 'distributions/navigation';

module.exports = {
  path: DEVICE_BATCHES_PATH,
  getComponent(nextState, cb) {
    require.ensure([], (require) => {
      cb(null, require('./components/DistributionDeviceBatches'));
    });
  },
};



// WEBPACK FOOTER //
// ./routes/app/routes/distributions/routes/show/routes/deviceBatches/index.js